'use client';

import * as React from 'react';
import Image from 'next/image';

import { APP_NAME } from '@workspace/common/app';
import { cn } from '@workspace/ui/lib/utils';

export type LogoElement = React.ComponentRef<'div'>;
export type LogoProps = React.ComponentPropsWithoutRef<'div'> & {
  hideSymbol?: boolean;
  hideWordmark?: boolean;
};
export function Logo({
  hideSymbol,
  hideWordmark,
  className,
  ...other
}: LogoProps): React.JSX.Element {
  return (
    <div
      className={cn('flex items-center space-x-2', className)}
      {...other}
    >
      {!hideSymbol && (
        <div className="flex p-1">
          <div className="flex h-7 items-center justify-center">
            <Image
              priority
              quality={100}
              src="/images/logo.png"
              alt="Logo CREmma"
              width={150}
              height={100}
              className="block dark:hidden"
            />
            <Image
              priority
              quality={100}
              src="/images/logo_dark.png"
              alt="Logo CREmma"
              width={150}
              height={100}
              className="hidden dark:block"
            />
          </div>
        </div>
      )}
      {!hideWordmark && <span className="font-bold">{APP_NAME}</span>}
    </div>
  );
}
